import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { FETCH_ARCHIVE_ACCEPTED } from '../../../redux/ArchiveTables';
import Table from '../../../components/Table/Table';
import { tablesHeaders } from '../../../consts/tablesConf';
import { ACCEPTED } from '../../../consts/navigation';
import { vehicleTypes } from '../../../consts/vehicleTypes';

class ArchiveAcceptedContainer extends PureComponent {
  static whichFolder = ACCEPTED;

  render() {
    const {
      fetchItems,
      totalCount,
      totalPages,
      data,
      renderRow,
      handleShowOffer,
      vehicleType,
    } = this.props;
    const { whichFolder } = ArchiveAcceptedContainer;
    return (
      <Table
        whichFolder={whichFolder}
        tableHeaders={tablesHeaders[vehicleType][whichFolder]}
        fetchOffers={fetchItems}
        onRowClick={handleShowOffer}
        totalCount={totalCount}
        totalPages={totalPages}
        renderRow={renderRow}
        items={data}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vehicleType: get(state, ['vehicleType', 'vehicleType']),
    data: get(state, ['archive', ACCEPTED, 'data']),
    totalCount: get(state, ['archive', ACCEPTED, 'total_count']),
    totalPages: get(state, ['archive', ACCEPTED, 'total_pages']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return { fetchItems: () => dispatch(FETCH_ARCHIVE_ACCEPTED()) };
};

ArchiveAcceptedContainer.propTypes = {
  fetchItems: PropTypes.func.isRequired,
  renderRow: PropTypes.func.isRequired,
  vehicleType: PropTypes.oneOf(Object.keys(vehicleTypes)).isRequired,
  handleShowOffer: PropTypes.func.isRequired,
  totalCount: PropTypes.number,
  totalPages: PropTypes.number,
};

ArchiveAcceptedContainer.defaultProps = {
  data: [],
  totalCount: 0,
  totalPages: 1,
};

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveAcceptedContainer);
